<template>
   <div class="profile-card container container-1200">
      <div class="row">
         <div class="col-12 img-container">
            <img loading="lazy" :src="datasrc.body[0].logoImage.file.url"
                 :alt="datasrc.body[0].logoImage.description">
         </div>
      </div>

      <div class="quote-grp">
         <img loading="lazy" src="../../../public/images/quote.svg"
              alt=""
              class="quote">
         <hr>
      </div>
      <div class="card profile-grp">
         <div>

            <p class="info">{{ datasrc.body[0].quote }}</p>

            <div class="media pt-3">
               <img loading="lazy" class=""
                    :src="datasrc.body[0].avatar && datasrc.body[0].avatar.file.url || '/public/images/profil-pic_dummy.png'">
               <div class="media-body">
                  <h6 class="mt-0 h6 text-dark"> {{ datasrc.body[0].name }} </h6>
                  <p class="small">
                     <em> {{ datasrc.body[0].designation }} </em>
                  </p>
               </div>
            </div>

            <div v-if="datasrc.ctas && datasrc.ctas.length">
               <hr>
               <div class="download-btn-con">
                  <a class="btn btn-primary-grad download-pdf">
                     <i class="fc_download" />Download PDF</a>
               </div>
            </div>

         </div>
      </div>
   </div>
</template>

<style lang="scss">
.profile-card {
   padding: 56px 38px 25px;
   padding-bottom: 12px;
   border-radius: 4px;
   box-shadow: 0 8px 10px 0 rgba(62, 57, 107, 0.04);
   background-color: #ffffff;

   hr {
      margin: 2.1rem 0;
   }

   .img-container {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
         width: auto;
         max-width: 100%;
         height: auto;
      }
   }

   .quote-grp {
      position: relative;
      i {
         position: absolute;
         top: -12px;
         left: 50%;
         margin-left: -13px;
         color: #f4f4fc;
      }
   }

   .media {
      img {
         border: 1px solid #cec8e8;
         border-radius: 50%;
         width: 40px;
      }
      .media-body {
         margin-top: 5px;
         padding: 0px 0px 0 15px;
         h6 {
            font-size: 14px;
            line-height: 18px;
            color: #212344;
         }
         .small {
            line-height: 15px;
            padding: 0;
            color: #434456;
            font-size: 12px;
         }
      }
   }

   .text-center {
      img {
         padding-top: 20px;
         padding-bottom: 10px;
      }
      h4 {
         margin: 0;
      }
   }

   .profile-grp {
      p.info {
         color: #434456;
         font-size: 16px;
         line-height: 29px;
      }
      p.small {
         line-height: 1.3;
      }

      h6 {
         line-height: 18px;
         color: #212344;
      }
      .btn {
         i {
            font-size: 18px;
            font-size: 1.8rem;
            padding-right: 0px;
            margin-right: 5px;
         }

         i,
         span {
            display: inline-block;
            vertical-align: middle;
         }
      }

      .cta-container {
         a {
            color: #6957da;
         }
      }
   }

   .quote {
      position: relative;
      width: 30px;
      height: 30px;
      top: 36px;
      left: 46%;
      opacity: 0.7;
   }

   .download-btn-con {
      width: 100%;
      text-align: center;
      .download-pdf {
         color: white !important;
      }
   }
}

.customer-details-wrapper {
   p {
      img {
         width: auto;
         max-width: 100%;
         height: auto;
      }
   }
}
</style>

<script>
export default {
   props: {
      datasrc: {
         type: Object,
         default: () => {},
      },
   },
};
</script>
